angular
  .module('ATMGurus')
  .component('atmgModal', {
    bindings: {
      // title: '='
    },
    template: (ATMGConf) => ATMGConf.templates.modals.index,
    bindToController: {
      title: '='
    },
    scope: true,
    controller: makeControllerFn()
  })

function makeControllerFn() {

  return class AtmgModal {

    constructor ($rootScope, ATMGConf, AddressBook, Checkout, FilterService, $scope, ApiCustomer, User, FormService, Auth) {

      this._conf = ATMGConf
      this.Customer = ApiCustomer
      this.AddressBook = AddressBook
      this.Checkout = Checkout
      this._$scope = $scope
      this._$rootScope = $rootScope
      this.FormService = FormService
      this.loading = false

      this.contactForm = {
        dept: 'customer.service@atmgurus.com',
        email: undefined,
        name: undefined
      }

      this.errors = {}

      Auth.isLogged()
        .then(() => {
          ApiCustomer.fetchUserData()
            .then(response => {
              let user = response.data.data
              this.contactForm.email =  user.email || undefined
              this.contactForm.name =  user.first_name || undefined
            })
            .catch(response => {})
        })
        .catch(response => {})

      let self = this
      this.countries = require('../../assets/lib/countries.json')

      this.modal = {
        visible: false,
        title: "Modal Title",
        template: 'success',
        data: Object.create({})
      }

      this.newAddress = {
        country: "US"
      }

      this.filters = FilterService.get("addresses")
      FilterService.get("contacts").take = 9999;
      // FilterService.fuzzySearch();

      this.turnPage = function( amount ) {
        if ( ( ( this.filters.page + amount ) > 0 )   ||  ( this.filters.page + amount ) <= AddressBook.pagination.total ) {
          AddressBook.pagination.current_page += amount;
          this.filters.page += amount;
        }
      }

      // @TODO Hmmmmm that controlled addrbook search on homepage? maybe?
      $scope.$watchGroup( ["MainCtrl.filters.page", "MainCtrl.filters.take"], function( nv, ov ) {
        if (nv !== ov) {
          self.fetchAddresses();
        }
      }, true)

      this.fetchAddresses = function() {
        this.AddressBook.fetchShippingAddresses(self.filters)
          .then(addresses => {
            if (addresses) {
              this.AddressBook.shippingAddresses = AddressBook.shippingAddresses;
            }
          })
          .catch(e => console.error(e))
      }

      this.hasError = function(field) {
        return this.errors[field] !== undefined
      }

      this.getError = function(field) {
        return this.errors[field]
      }

      // this.AddressBook = AddressBook
      // this.Checkout = Checkout

      $rootScope.$on('modal.error', (e, error) => this.errors = error)
      $rootScope.$on('modal.clear_error', () => this.errors = {} )

      $rootScope.$on('modal.open', (e, options) => this.open(e, options))
      $rootScope.$on('modal.close', () => this.close())
    }


    $onInit () {
      console.log('init modal component')
    }

    checkCustomerNumber (customer_number) {
      // clean previous error if present
      let payload = {
        success: true,
        customer_number: customer_number
      }

      this.Customer.checkCustomerNumber(customer_number)
        .then(response => {
          this.modal.visible = false
          this._$rootScope.$broadcast("customerLinked", {success: true, customer_number: customer_number})
        })
        .catch(error => {
          this.modal.visible = false
          this._$rootScope.$broadcast("customerLinked", {success: false, customer_number: undefined, error: error})
        })
    }


      submit(type) {
        this._$scope.$emit("modal.open", {})
        this.FormService.post('web-forms/' + type, this.contactForm)
          .then(response => {
            this._$scope.$emit("modal.close", {} )
            if (response) {
              this._$scope.$emit("modal.open", { title: "Contact request", template: 'success', data: { message: response.message} } )
            }
            else {
              this._$scope.$emit("modal.open", { title: "Contact request", template: 'error', data: { message: reason.message } } )
            }
          })
          .catch(reason => {
            this._$scope.$emit("modal.open", { title: "Contact request", template: 'error', data: { message: reason } } )
          })
      }

    selectCustomer (customer) {
      this.modal.data.selected = customer
      this.callback(customer)
      this.close()
    }

		addContact () {
      return this.AddressBook.addContact(this.newAddress);
    }

    // add both address and contact
    addDropShip () {
      this._$scope.$emit("modal.open", { title: "Adding New Address" })
    	return this.AddressBook.addDropShip(this.newAddress)
    		.then(data => {
    			var customer_name = self.newAddress.customer_name;
    			self.newAddress = {
    				country: "US",
    				customer_name: self.newAddress.customer_name
    			}
    		})
    }

    // clear addressbook
    clearAddressbook () {
      this.close()
      this.newAddress = {
        country: "US"
      }
    }

    open (e, options) {
      this.loading = false
      this.modal.title = options.title || 'Modal'
      this.modal.visible = true
      this.modal.template = options.template || 'loading'
      this.modal.data = options.data || Object.create({})
      this.callback = options.callback || function() {}
    }

    close () {
      this.modal.visible = false
    }

    turnAgingPage (amt) {
      this.loading = true
      this._$rootScope.$broadcast('turn-aging', amt)
    }

  }
}


// WEBPACK FOOTER //
// ./src/app/components/modal-component.js